import React from 'react';
import { Gamepad2, Loader2 } from 'lucide-react';
import { GameSummary } from '@/api/types';
import { DesktopGameCard } from './desktop-game-card';
import styles from './desktop-game-grid.module.css';

interface DesktopGameGridProps {
  games: GameSummary[];
  title?: string;
  isLoading?: boolean;
  emptyText?: string;
}

export const DesktopGameGrid: React.FC<DesktopGameGridProps> = ({
  games,
  title = '全部游戏',
  isLoading = false,
  emptyText = '暂无游戏',
}) => {
  if (isLoading) {
    return (
      <section className={styles.section}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <Gamepad2 className={styles.icon} size={22} />
            {title}
          </h2>
        </div>
        <div className={styles.loading}>
          <Loader2 className={styles.spinner} size={32} />
          <p>加载中...</p>
        </div>
      </section>
    );
  }

  if (games.length === 0) {
    return (
      <section className={styles.section}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <Gamepad2 className={styles.icon} size={22} />
            {title}
          </h2>
        </div>
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>🎮</div>
          <p>{emptyText}</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <Gamepad2 className={styles.icon} size={22} />
          {title}
        </h2>
        <span className={styles.count}>共 {games.length} 款游戏</span>
      </div>
      <div className={styles.grid}>
        {games.map((game) => (
          <DesktopGameCard key={game.id} game={game} />
        ))}
      </div>
    </section>
  );
};

export default DesktopGameGrid;
